import { useCallback, useEffect, useState } from "react";
import { api } from "../../../lib/api";
import { useAuth } from "../../../providers/AuthProvider";

export type PurchaseOrderListRow = {
  id: string;
  dealer: { id: string; name: string };
  status: string;
  ordered_qty_total: string;
  received_qty_total: string;
  expected_delivery_date: string | null;
  created_at: string | null;
};

export function usePurchaseOrders(filters: { status?: string; dealerId?: string }) {
  const { token } = useAuth();
  const [rows, setRows] = useState<PurchaseOrderListRow[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const reload = useCallback(async () => {
    if (!token) return;
    setLoading(true);
    setError(null);
    try {
      const res = await api.purchaseOrders.listPO({
        token,
        status: filters.status,
        dealerId: filters.dealerId,
      });
      setRows(res.data);
    } catch (e) {
      setError(e instanceof Error ? e.message : "Failed to load purchase orders");
    } finally {
      setLoading(false);
    }
  }, [token, filters.status, filters.dealerId]);

  useEffect(() => {
    void reload();
  }, [reload]);

  return { rows, loading, error, reload };
}
